/**
 * @fileoverview Recoveries section registry.
 *
 * Single source of truth for the sub-sections of the Recoveries phase —
 * consumed by the sidebar sub-tabs, the phase overview cards, the
 * `$section` detail route, and the breadcrumb. Mirrors
 * `review/reviewRegistry.ts` so the two phases behave identically.
 *
 * Adding a section (demands, settlement negotiations, litigation
 * tracking) means adding an entry here and a branch in the `$section`
 * route.
 */

import { Scale, type LucideIcon } from "lucide-react";

export interface RecoverySectionEntry {
  /** URL slug used in /dashboard/jobs/$jobId/recoveries/$section. */
  slug: string;
  /** Human-readable label shown in the sidebar, breadcrumb, and card. */
  label: string;
  /** Lucide icon rendered everywhere this section appears. */
  icon: LucideIcon;
  /** Short blurb used on the overview card body. */
  description: string;
}

export const RECOVERY_SECTIONS: ReadonlyArray<RecoverySectionEntry> = [
  {
    slug: "proof-of-debt",
    label: "Proof of Debt",
    icon: Scale,
    description:
      "Adjudicate creditor claims by reconciling supporting documents and the books and records against the amount claimed.",
  },
];

/** slug → entry. */
export const RECOVERY_SECTIONS_BY_SLUG: ReadonlyMap<
  string,
  RecoverySectionEntry
> = new Map(RECOVERY_SECTIONS.map((s) => [s.slug, s]));

/**
 * Agent-activity key recorded when a Form 535 lands (`podIngestion`).
 * Sidebar badges and the claims table's "New" underline both key off this.
 */
export const POD_INTAKE_AGENT_KEY = "recoveries_pod_intake";
